
import { Box, IconButton, Text } from '@chakra-ui/react';
import { ArrowBackIcon, ArrowForwardIcon, TimeIcon } from '@/components/icons/Icon';
import { Tooltip } from "@/components/ui/tooltip";

type YearNavigationProps = {
    currentYear: number;
    setCurrentYear: (number) => void;
};

const YearNavigation = ({ currentYear, setCurrentYear }: YearNavigationProps) => {
    return (
        <Box display="flex" alignItems="center" flexWrap="wrap" gap={2} minW={0} w="fit-content" maxW="full" mb={{ base: 4, md: 0 }}>
            <IconButton
                variant='outline'
                size='sm'
                colorPalette='blue'
                aria-label='Previous'
                onClick={() => setCurrentYear(currentYear - 1)}
            ><ArrowBackIcon /></IconButton>
            <Text minW={0} flex="1" fontSize="2xl" fontWeight={'bold'} textAlign={'center'}>{currentYear}</Text>
            <IconButton
                variant='outline'
                size='sm'
                colorPalette='blue'
                aria-label='Next'
                onClick={() => setCurrentYear(currentYear + 1)}
            ><ArrowForwardIcon /></IconButton>
            <Tooltip content='Dieses Jahr'>
                <IconButton
                    variant='outline'
                    size='sm'
                    colorPalette='blue'
                    aria-label='Dieses Jahr'
                    ml={{ base: 0, md: 3 }}
                    onClick={() => setCurrentYear(new Date().getFullYear())}
                ><TimeIcon /></IconButton>
            </Tooltip>
        </Box>
    );
}

export default YearNavigation;
